import { createContext, useEffect, useState, useRef } from "react";
import Pusher from "pusher-js";
import { getGeolocationPermissionState, getTableKeysLocalStorage, isProduction, updateTableKeysLocalStorage } from "./utils";
import { updateUser } from "./ApiHandlers";
import ISSTracker from "./ISSTracker";
import TrafficMap from "./TrafficMap";
import WindyMap from "./WindyMap";
import TransporteCrianza from "./TransporteCrianza";

export const contexto = createContext();
const Provider = contexto.Provider;


const ADMIN_UIDS = [
    "LJ6xawWJheUWBbChukhyen6gBCf1",
    "EuFKs5ABkCM9AGUWMTo98R40ivo1",
    "3IzkCxr4PaO5A5JlZpnAtmuHCxk2",
    "5dxKTVDluFY6mRo3krktdwBf5eP2", //Crianza administracion
];

const CustomProvider = ({ children }) => {
    const [canalesDisponiblesTodos, setCanalesDisponiblesTodos] = useState([]);
    const [usuarioContexto, setUsuarioContexto] = useState({});
    const [usuariosActivosCantidad, setUsuariosActivosCantidad] = useState(0);

    const [tandasPublicitarias, setTandasPublicitarias] = useState({});

    const authToken = useRef(null);

    const pusherRef = useRef(null);
    const channelPusherRef = useRef(null);
    const intervalUsersAliveRef = useRef(null);
    const clarityInitializedRef = useRef(false);

    const UIDS_HABILITADOS = new Set([
        "LJ6xawWJheUWBbChukhyen6gBCf1",
        "EuFKs5ABkCM9AGUWMTo98R40ivo1",
        "3IzkCxr4PaO5A5JlZpnAtmuHCxk2",
        "5dxKTVDluFY6mRo3krktdwBf5eP2", //Crianza administracion localhost
    ]);

    // Obtener el dispositivo actual desde usuarioContexto
    const getThisDevice = () => {
        // console.log("🔍 getThisDevice() llamado");

        try {
            const deviceId = getTableKeysLocalStorage("deviceID");
            // console.log("🆔 deviceID desde LS:", deviceId);

            if (!deviceId) {
                console.warn("⚠️ No hay deviceID en localStorage");
                return null;
            }

            if (!usuarioContexto?.dispositivos) {
                return null;
            }

            const device = usuarioContexto.dispositivos.find(d => d.deviceId === deviceId);
            // console.log("📱 Dispositivo encontrado:", device);

            return device || null;
        } catch (err) {
            console.error("❌ Error en getThisDevice:", err);
            return null;
        }
    };

    const thisDevice = getThisDevice();
    const userLocation = thisDevice?.location || null;

    // console.log("📍 thisDevice:", thisDevice);
    // console.log("📍 userLocation:", userLocation);

    const onUserLogueado = (data) => {
        // console.log("👤 onUserLogueado llamado con:", data);

        setUsuarioContexto(prev => {
            const nuevo = { ...prev, ...data };
            // console.log("👤 usuarioContexto actualizado:", nuevo);
            return nuevo;
        });

        try {
            // console.log("🌐 updateUser()", data.uid);
            updateUser(data.uid, data);

            // console.log("💾 Guardando user en localStorage");
            updateTableKeysLocalStorage("user", data);
        } catch (err) {
            console.error("❌ Error en onUserLogueado:", err);
        }
    };

    const generateSpecialChannels = () => {
        const canalesEspeciales = [
            {
                id: 'custom-iss-tracker',
                channelTitle: 'ISS Tracker',
                title: 'Rastreador de la Estación Espacial Internacional',
                type: 'custom-component',
                render: ISSTracker,
                color: '#1e40af',
                isCustomChannel: true,
                requiresLocation: true
            },
            {
                id: 'custom-traffic-map',
                channelTitle: 'Mapa del tráfico',
                title: 'Tráfico',
                type: 'custom-component',
                render: TrafficMap,
                color: '#ff0000',
                isCustomChannel: true,
                requiresLocation: true
            },
            {
                id: 'custom-clima-tormentas',
                channelTitle: 'Clima - Tormentas',
                title: 'Widget del clima - Tormentas',
                type: 'custom-component',
                render: WindyMap,
                color: '#06b6d4',
                isCustomChannel: true,
                requiresLocation: true
            },
        ];

        if (usuarioContexto?.uid === "LJ6xawWJheUWBbChukhyen6gBCf1" || usuarioContexto?.uid === "5dxKTVDluFY6mRo3krktdwBf5eP2" || usuarioContexto?.uid === "EuFKs5ABkCM9AGUWMTo98R40ivo1" || usuarioContexto?.uid === "3IzkCxr4PaO5A5JlZpnAtmuHCxk2") {
            return [
                ...canalesEspeciales,
                // {
                //     id: 'alltack-crianza-1',
                //     channelTitle: 'Transporte Crianza',
                //     title: 'Transporte Crianza',
                //     type: 'custom-component',
                //     render: TransporteCrianza,
                //     color: '#10b981',
                //     isCustomChannel: true,
                //     requiresLocation: true
                // },

                // {
                //     id: 'futbol-foxsports',
                //     channelTitle: 'FoxSports',
                //     title: 'Descripción del canal',
                //     type: 'iframe',
                //     url: 'https://la14hd.com/vivo/canales.php?stream=foxsports',
                //     color: '#10b981',
                //     isCustomChannel: true,
                //     requiresLocation: false
                // },
                // {
                //     id: 'futbol-foxsports2',
                //     channelTitle: 'Fox Sports 2',
                //     title: 'Descripción del canal',
                //     type: 'iframe',
                //     url: 'https://streamtp10.com/global1.php?stream=fox1ar',
                //     color: '#10b981',
                //     isCustomChannel: true,
                //     requiresLocation: true
                // },
                {
                    id: 'futbol-tycsports',
                    channelTitle: 'TyC Sports',
                    title: 'Descripción del canal',
                    type: 'iframe',
                    // url: 'https://streamtp10.com/global1.php?stream=tycsports',
                    ulr: 'https://streamtpday1.xyz/global1.php?stream=tycsports',
                    color: '#10b981',
                    isCustomChannel: true,
                    requiresLocation: true
                },

                {
                    id: 'telefe',
                    channelTitle: 'Telefe',
                    title: 'Descripción del canal',
                    type: 'iframe',
                    // url: 'https://streamtp10.com/global1.php?stream=tycsports',
                    ulr: 'https://streamtpday1.xyz/global1.php?stream=telefe',
                    color: '#10b981',
                    isCustomChannel: true,
                    requiresLocation: true
                },

                // {
                //     id: 'futbol-espnpremium',
                //     channelTitle: 'ESPN Premium',
                //     title: 'Descripción del canal',
                //     type: 'iframe',
                //     url: 'https://la14hd.com/vivo/canal.php?stream=espnpremium',
                //     color: '#10b981',
                //     isCustomChannel: true,
                //     requiresLocation: true
                // },
                // {
                //     id: 'futbol-espnpremium2',
                //     channelTitle: 'ESPN Premium 2',
                //     title: 'Descripción del canal',
                //     type: 'iframe',
                //     url: 'https://streamtp10.com/global1.php?stream=espnpremium',
                //     color: '#10b981',
                //     isCustomChannel: true,
                //     requiresLocation: true
                // },
                {
                    id: 'futbol-tntsport',
                    channelTitle: 'TNT Sports',
                    title: 'Descripción del canal',
                    type: 'iframe',
                    // url: 'https://la14hd.com/vivo/canal.php?stream=tntsports',
                    ulr: 'https://streamtpday1.xyz/global1.php?stream=max1',
                    color: '#10b981',
                    isCustomChannel: true,
                    requiresLocation: true
                },
                {
                    id: 'futbol-dsports',
                    channelTitle: 'DirecTV Sports',
                    title: 'Descripción del canal',
                    type: 'iframe',
                    ulr: 'https://sudamericaplay2.com/canal_8112/cza_dsports.html',
                    color: '#10b981',
                    isCustomChannel: true,
                    requiresLocation: true
                },

            ];
        }

        return canalesEspeciales;
    };

    /**** USERS ALIVE ****/
    useEffect(() => {
        const getUsersAliveQuantity = () => {
            fetch("https://rai-backend-production.up.railway.app/cajaboba/usuariosactivos-cantidad")
                .then(r => r.json())
                .then(response => {
                    if (response.activos !== undefined) {
                        setUsuariosActivosCantidad(response.activos);
                    }
                })
                .catch(err => console.error("❌ Error usuarios activos:", err));
        };

        getUsersAliveQuantity();

        intervalUsersAliveRef.current = setInterval(getUsersAliveQuantity, 60 * 1000);

        return () => {
            clearInterval(intervalUsersAliveRef.current);
            intervalUsersAliveRef.current = null;
        };
    }, []);


    /**** PUSHER TANDAS ****/
    useEffect(() => {
        if (!usuarioContexto?.uid) return;
        if (!UIDS_HABILITADOS.has(usuarioContexto.uid)) return;
        if (!isProduction()) return;

        if (!pusherRef.current) {
            pusherRef.current = new Pusher("52265056c992ea254be6", { cluster: "us2" });
            channelPusherRef.current = pusherRef.current.subscribe("lacajaboba");

            channelPusherRef.current.bind("tandaPublicitaria", (data) => {
                if (data && data.channelId) {
                    setTandasPublicitarias((prevTandas) => ({
                        ...prevTandas,
                        [data.channelId]: data.esTanda,
                    }));
                }
            });
        }

        return () => {
            channelPusherRef.current?.unbind_all();
            channelPusherRef.current?.unsubscribe();
            pusherRef.current?.disconnect();
            pusherRef.current = null;
            channelPusherRef.current = null;
        };
    }, [usuarioContexto?.uid]);



    //Primera carga y detección de ADs
    useEffect(() => {
        if (!usuarioContexto?.uid) {
            try {
                const dataLS = getTableKeysLocalStorage("user");
                if (dataLS?.uid) {
                    setUsuarioContexto(dataLS);
                }
            } catch (error) {
                console.error("❌ Error leyendo user LS:", error);
            }
        }

        if (usuarioContexto?.uid) {
            try {
                const adGuardado = localStorage.getItem("CAJABOBA-adsource");

                if (adGuardado) {
                    const ad = {};
                    ad['source'] = adGuardado;
                    ad['date'] = JSON.parse(localStorage.getItem("CAJABOBA-adsource-date"));

                    updateUser(usuarioContexto.uid, { ad });
                    localStorage.removeItem("CAJABOBA-adsource");
                    localStorage.removeItem("CAJABOBA-adsource-date");
                }
            } catch (error) {
                console.log("Error Ad src:");
                console.log(error);
            }
        }
    }, [usuarioContexto?.uid]);




    /**** CLARITY ****/
    useEffect(() => {
        if (clarityInitializedRef.current) return;
        if (!canalesDisponiblesTodos.length) return;
        if (!usuarioContexto?.uid) return;
        if (!isProduction()) return;

        const CLARITY_ID = "fkmdh5mpmn";

        // Función para inicializar Clarity DESPUÉS de que el DOM esté listo
        const initClarity = () => {
            (function (c, l, a, r, i, t, y) {
                c[a] = c[a] || function () {
                    (c[a].q = c[a].q || []).push(arguments);
                };
                t = l.createElement(r);
                t.async = 1;
                t.src = "https://www.clarity.ms/tag/" + i;
                y = l.getElementsByTagName(r)[0];
                y.parentNode.insertBefore(t, y);
            })(window, document, "clarity", "script", CLARITY_ID);

            clarityInitializedRef.current = true;
        };

        // Esperar a que React termine de renderizar
        // Usando requestIdleCallback para mayor seguridad
        if ('requestIdleCallback' in window) {
            requestIdleCallback(() => {
                setTimeout(initClarity, 1000);
            });
        } else {
            setTimeout(initClarity, 2000);
        }

    }, [canalesDisponiblesTodos.length, usuarioContexto?.uid]);

    useEffect(() => {
        if (!window.clarity) return;
        if (!usuarioContexto?.uid) return;

        window.clarity("set", "user_name", usuarioContexto.displayName);
        window.clarity("set", "user_uid", usuarioContexto.uid);

    }, [usuarioContexto?.uid, usuarioContexto?.displayName]);




    const fetchChannels = async () => {
        try {
            const baseURL = isProduction() ? window.location.origin : 'http://localhost:8080';

            const response = await fetch(`${baseURL}/api/canales`);

            if (!response.ok) {
                throw new Error("Response no OK");
            }

            const data = await response.json();

            const specialChannels = generateSpecialChannels();
            setCanalesDisponiblesTodos([...specialChannels, ...data.channels]);

            updateTableKeysLocalStorage("canales", data.channels);
        } catch (err) {
            console.error("❌ Error fetchChannels:", err);
        }
    };

    useEffect(() => {
        if (canalesDisponiblesTodos.length === 0) {
            const canalesLS = getTableKeysLocalStorage("canales");
            if (canalesLS) {
                const specialChannels = generateSpecialChannels();
                setCanalesDisponiblesTodos([...specialChannels, ...canalesLS]);
            }
            fetchChannels();
        }

        //Especial duplicado para canales especiales
        if (canalesDisponiblesTodos.length && ADMIN_UIDS.indexOf(usuarioContexto?.uid) >= 0) {
            fetchChannels();
        }
    }, [usuarioContexto?.uid]); //Quitar cuando se deje de probar canales especiales


    useEffect(() => {
        if (!usuarioContexto?.uid || !thisDevice?.deviceId) return;

        const checkPermissionAndAct = async () => {
            const state = await getGeolocationPermissionState();

            if (state === 'granted') {
                // 🔕 Silencioso, sin modal
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const { latitude, longitude, accuracy } = position.coords;
                        updateUserLocation({ latitude, longitude, accuracy: parseInt(accuracy), updated: new Date() })

                        // setTimeout(() => {
                        //     updateUserLocation({
                        //         latitude: Math.floor(Math.random() * 41) + 10,
                        //         longitude: Math.floor(Math.random() * 41) + 10,
                        //         accuracy: 1,
                        //         updated: new Date()
                        //     })
                        // }, 5 * 1000);
                    },
                    (err) => {
                        console.error(err);
                    },
                    {
                        enableHighAccuracy: true,
                        timeout: 10000,
                        maximumAge: 60000
                    }
                );
            }
            else {
                console.log("Modal silencioso: ", state)
            }
        };

        checkPermissionAndAct();
    }, [usuarioContexto?.uid, thisDevice?.deviceId]);


    const updateUserLocation = (location) => {
        // console.log("📍 updateUserLocation()", location);

        if (!usuarioContexto?.uid) {
            console.warn("⚠️ No hay usuario logueado");
            return;
        }

        const deviceId = getTableKeysLocalStorage("deviceID");
        if (!deviceId) {
            console.warn("⚠️ No hay deviceID");
            return;
        }

        const dispositivos = usuarioContexto.dispositivos || [];
        const currentDevice = dispositivos.find(device => device.deviceId === deviceId);

        // Verificar si hay cambios significativos en la ubicación
        const hasLocationChanged = () => {
            if (!currentDevice?.location) return true; // Primera vez

            const oldLoc = currentDevice.location;
            const newLoc = location;

            // Comparar coordenadas con un margen de tolerancia (0.0001 grados ≈ 11 metros)
            const latChanged = Math.abs(oldLoc.latitude - newLoc.latitude) > 0.0001;
            const lonChanged = Math.abs(oldLoc.longitude - newLoc.longitude) > 0.0001;

            // Cambio significativo en accuracy (más de 50 metros de diferencia)
            const accuracyChanged = Math.abs((oldLoc.accuracy || 0) - (newLoc.accuracy || 0)) > 50;

            return latChanged || lonChanged || accuracyChanged;
        };

        if (!hasLocationChanged()) {
            return;
        }

        // Actualizar dispositivo preservando todas sus propiedades
        const updatedDispositivos = dispositivos.map(device =>
            device.deviceId === deviceId
                ? { ...device, location, locationStatus: "success" }
                : device
        );

        const updatedUser = {
            ...usuarioContexto,
            dispositivos: updatedDispositivos
        };

        setUsuarioContexto(updatedUser);
        updateTableKeysLocalStorage("user", updatedUser);

        // Solo escribir en backend si hay cambios reales
        updateUser(usuarioContexto.uid, { dispositivos: updatedDispositivos })

        const specialChannels = generateSpecialChannels();
        const canalesLS = getTableKeysLocalStorage("canales") || [];
        setCanalesDisponiblesTodos([...specialChannels, ...canalesLS]);
    };


    const valorDelContexto = {
        canalesDisponiblesTodos,
        fetchChannels,
        setCanalesDisponiblesTodos,
        onUserLogueado,
        tandasPublicitarias,
        thisDeviceData: thisDevice,
        usuarioContexto,
        setUsuarioContexto,
        userLocation,
        updateUserLocation,
        usuariosActivosCantidad,
        authToken
    };

    return (
        <Provider value={valorDelContexto}>
            {children}
        </Provider>
    );
};

export default CustomProvider;
